import {lazy} from 'react';
import {Form} from 'semantic-ui-react';
import './timepicker.scss';

const TimeKeeper = lazy(function () {
  return import('react-timekeeper');
});

function FormTimePicker(props) {
  const {
    input: {name, value, onChange},
    required, label, placeholder, size,
    meta: {touched, error}
  } = props;
  const id = props.id || name;
  const exactLabel = ['.', '?', '!', '؟'].includes(label.charAt(label.length - 1));

  return (
    <Form.Field
      id={id}
      label={exactLabel ? label : `${label} :`}
      required={required}
      control={TimeKeeper}
      placeholder={placeholder}
      size={size}
      error={(touched && error != null) ? error : false}
      time={value}
      hour24Mode
      forceCoarseMinutes
      switchToMinuteOnHourSelect
      coarseMinutes={5}
      onChange={(newTime) => onChange(newTime.formatted24)}
    />
  );
}

export default FormTimePicker;

